
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { formatUnit } from "@/utils/habitUtils";
import { useToast } from "@/hooks/use-toast";

interface HabitProgressDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  dailyTarget?: {
    value: number;
    unit: string;
  };
  dailyProgress?: number;
  onSubmit: (progress: number) => void;
}

export const HabitProgressDialog = ({
  open,
  onOpenChange,
  dailyTarget,
  dailyProgress,
  onSubmit
}: HabitProgressDialogProps) => {
  const [progressInput, setProgressInput] = useState("");
  const { toast } = useToast();

  const handleSubmit = () => {
    const progress = parseFloat(progressInput);
    if (!isNaN(progress)) {
      onSubmit(progress);
      setProgressInput("");
    } else {
      toast({
        title: "Invalid input",
        description: "Please enter a valid number",
        variant: "destructive",
      });
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Enter Daily Progress</DialogTitle>
          <DialogDescription>
            {dailyProgress !== undefined && dailyTarget 
              ? `Current progress: ${dailyProgress.toFixed(1)} ${formatUnit(dailyTarget.unit)} out of ${dailyTarget.value} ${formatUnit(dailyTarget.unit)}`
              : `Please enter your progress (${dailyTarget?.unit})`
            }
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <Input
            type="number"
            step="0.1"
            value={progressInput}
            onChange={(e) => setProgressInput(e.target.value)}
            placeholder={`Enter amount in ${dailyTarget?.unit}`}
          />
          <div className="flex justify-end space-x-2">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button onClick={handleSubmit}>
              Submit
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
